import { Spin } from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Col, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { Field, FormikProvider, useFormik } from "formik";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import * as Yup from "yup";
import {
  POST_GetCustomerDDLListAJAX,
  POST_GetItemDCList,
  POST_GetItemDCPrintHTMLContents,
  POST_ItemDCDelete,
} from "../../../helpers/url_helper";
import { post } from "../../../helpers/api_helper";
import CustomSizePerPage from "../../../CustomControls/CustomSizePerPage";
import CustomPaginationButtons from "../../../CustomControls/CustomPaginationButtons";
import { SVGICON } from "../../../constant/theme";
import { delete_Record } from "../CommonFunctions";
import { errorMessage } from "../CommonFunctions";
import { useFilter } from "../../../../context/FilterContext";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import moment from "moment";
import CustomSelectAsync from "../../../CustomControls/CustomSelectAsync";

const InventoryItemDC = () => {
  const { filter, updateFilter } = useFilter();
  const [showFilter, setShowFilter] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(
    filter && filter?.page == "item-dc" ? filter?.CurrentPage : 1
  );
  const [currentSizePerPage, setCurrentSizePerPage] = useState(
    filter && filter?.page == "item-dc" ? filter?.PageSize : 10
  );
  const [recordCount, setRecordCount] = useState(0);
  const [sortBy, setSortBy] = useState(
    filter && filter?.page == "item-dc" ? filter?.sortBy : ""
  );
  const [orderBy, setOrderBy] = useState(
    filter && filter?.page == "item-dc" ? filter?.orderBy : "asc"
  );
  const [itemDCList, setItemDCList] = useState([]);
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;
  const [isReset, setIsReset] = useState(false);

  const handleClickSorting = (columnName) => {
    if (sortBy == columnName) {
      if (orderBy == "asc") {
        setOrderBy("desc");
      } else {
        setSortBy("");
        setOrderBy("asc");
      }
    } else {
      setSortBy(columnName);
      setOrderBy("asc");
    }
  };

  const validationSchema = Yup.object().shape({});

  const formikFilter = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      Search: filter && filter?.page == "item-dc" ? filter?.Search : "",
      FromDate:
        filter && filter?.page == "item-dc" ? filter?.FromDate : new Date(),
      ToDate: filter && filter?.page == "item-dc" ? filter?.ToDate : new Date(),
      CustomerIDEncrypted:
        filter && filter?.page == "item-dc" ? filter?.CustomerIDEncrypted : "",
      CustomerName:
        filter && filter?.page == "item-dc" ? filter?.CustomerName : "",
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmit,
    values: { Search, FromDate, ToDate, CustomerIDEncrypted, CustomerName },
  } = formikFilter;

  useEffect(() => {
    getData(1, currentSizePerPage);
  }, [sortBy, orderBy]);

  useEffect(() => {
    if (isReset == true) {
      getData(currentPage, currentSizePerPage);
      setIsReset(false);
    }
  }, [isReset]);

  useEffect(() => {
    if (ToDate && ToDate < FromDate) {
      formikFilter.setFieldValue("ToDate", FromDate);
    }
  }, [FromDate]);

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);

    updateFilter({
      page: "item-dc",
      CurrentPage: page,
      PageSize: sizePerPage,
      sortBy: sortBy,
      orderBy: orderBy,
      CustomerIDEncrypted: CustomerIDEncrypted,
      CustomerName: CustomerName,
      FromDate: FromDate ? FromDate : "",
      ToDate: ToDate ? ToDate : "",
    });

    let payload = {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: Search,
      Sorting: sortBy ? sortBy + " " + orderBy : "",
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CustomerIDEncrypted: CustomerIDEncrypted,
      FromDate: moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, ""),
      ToDate: moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, ""),
    };

    await post(POST_GetItemDCList, payload)
      .then((response) => {
        setRecordCount(response?.TotalRecordCount);
        setItemDCList(response?.List);
        setIsLoading(false);

        if (page > 1 && response?.List?.length === 0) {
          setCurrentPage(page - 1);
          getData(page - 1, sizePerPage);
        } else {
          setCurrentPage(page);
        }
        setCurrentSizePerPage(sizePerPage);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const fnCallback = () => {
    getData(currentPage, currentSizePerPage);
  };

  const getResetData = async () => {
    setIsLoading(true);

    // formikFilter.resetForm();
    formikFilter.setValues({
      FromDate: new Date(),
      ToDate: new Date(),
      Search: "",
      CustomerIDEncrypted: "",
      CustomerName: "",
    });

    setCurrentPage(1);
    setSortBy("");
    setOrderBy("asc");

    setIsReset(true);
  };

  const getItemDCPrintHTMLContents = async (ItemDCIDEncrypted) => {
    setIsLoading(true);
    await post(POST_GetItemDCPrintHTMLContents, {
      ItemDCIDEncrypted: ItemDCIDEncrypted,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          let iframe = document.getElementById("iFrameItemDC");
          if (iframe) {
            iframe.setAttribute("srcDoc", response?.HTMLContents);
            setTimeout(() => {
              iframe.contentWindow.print();
            }, 300);
          }
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const loadOptionsCustomer = (inputValue) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(getCustomerDDL_AJAX(inputValue));
      }, 1000);
    });
  };

  const getCustomerDDL_AJAX = async (inputValue) => {
    return await post(POST_GetCustomerDDLListAJAX, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      SearchValue: inputValue ?? "",
      TPIFlag: -1, // 0 = Only Customer, 1 = Only TPI,  -1 = All (Customer & TPI both)
    })
      .then((response) => {
        if (response?.IsSuccess) {
          return response?.CustomerDDLList?.map((item) => ({
            label: item.CustomerName,
            value: item.CustomerIDEncrypted,
          }));
        } else {
          return [];
        }
      })
      .catch((error) => {
        console.log(error);
        return [];
      });
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="table-responsive active-projects style-1 shorting">
              <div className="tbl-caption p-2">
                <h4 className="heading mb-0">Item DC</h4>
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getResetData();
                    }}
                  >
                    <i
                      className="fa fa-window-restore me-2"
                      aria-hidden="true"
                    ></i>
                    Reset
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getData();
                    }}
                  >
                    <i className="fa-solid fa-refresh me-2"></i> Reload
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => setShowFilter(!showFilter)}
                  >
                    <i className="fa-solid fa-filter me-2"></i>Filter
                  </button>

                  {AuthUser?.UserType !== 1 ||
                  formsList?.filter((x) => x?.FormID == 99 && x?.IsAdd)
                    ?.length > 0 ? (
                    <Link
                      to="/add-item-dc"
                      className="btn btn-outline-primary btn-sm"
                    >
                      <i className="fa-solid fa-plus"></i> Add Item DC
                    </Link>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <hr className="mt-0 mb-1"></hr>
              <div className="p-2 pt-0 pb-0">
                {showFilter ? (
                  <div>
                    <FormikProvider value={formikFilter}>
                      <Form onSubmit={formikFilter.handleSubmit}>
                        <Row className="me-0">
                          <Col lg={3}>
                            <Field
                              label="Search"
                              name="Search"
                              placeholder={"Search here..."}
                              component={CustomInput}
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Customer"
                              name="CustomerIDEncrypted"
                              placeholder={"Select Customer"}
                              loadOptionsFn={loadOptionsCustomer}
                              component={CustomSelectAsync}
                              title={CustomerName}
                              labelFieldName="CustomerName"
                              menuPosition="fixed"
                            />
                          </Col>
                          <Col lg={3}>
                            <label className="mb-1">DC Date</label>
                            <div className="d-flex">
                              <Field
                                name="FromDate"
                                placeholder={"From Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                }}
                              />
                              <div>&nbsp;</div>
                              <Field
                                name="ToDate"
                                placeholder={"To Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                  minDate: FromDate,
                                }}
                              />
                            </div>
                          </Col>
                          <Col lg={3}>
                            <label className="mb-1">&nbsp;</label>
                            <div className="d-flex">
                              <div className="d-lg-block">
                                <Link
                                  className="btn btn-primary btn-sm"
                                  onClick={(e) => {
                                    getData();
                                  }}
                                >
                                  <i
                                    className="fa fa-search"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  Search
                                </Link>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </FormikProvider>
                  </div>
                ) : (
                  ""
                )}
                <div
                  id="Item-DC-tbl_wrapper"
                  className="dataTables_wrapper no-footer"
                >
                  <table
                    id="Item-DC-tbl"
                    className="table dataTable no-footer mb-0"
                  >
                    <thead>
                      <tr>
                        <th width="1%"></th>
                        <th
                          style={{
                            width: "10%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("DCNo");
                          }}
                        >
                          DC No{" "}
                          <span className="ml-1">
                            {sortBy == "DCNo" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "39%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("CustomerName");
                          }}
                        >
                          Customer Name{" "}
                          <span className="ml-1">
                            {sortBy == "CustomerName" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "39%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("CustomerName");
                          }}
                        >
                          Employee Name{" "}
                          <span className="ml-1">
                            {sortBy == "CustomerName" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "11%",
                            cursor: "pointer",
                            textAlign: "left",
                          }}
                          onClick={() => {
                            handleClickSorting("DCDate");
                          }}
                        >
                          DC Date{" "}
                          <span className="ml-1">
                            {sortBy == "DCDate" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {itemDCList?.length > 0 ? (
                        itemDCList?.map((item, indx) => (
                          <tr key={indx}>
                            <td>
                              {AuthUser?.UserType !== 1 ||
                              formsList?.filter(
                                (x) => x?.FormID == 99 && x?.IsEdit
                              )?.length > 0 ? (
                                <Link
                                  to={`/edit-item-dc/${window.btoa(
                                    item.ItemDCIDEncrypted
                                  )}`}
                                  className="icon-box icon-box-md me-1"
                                  title="Edit"
                                >
                                  {SVGICON.EditPrimary}
                                </Link>
                              ) : (
                                ""
                              )}
                              {AuthUser?.UserType !== 1 ||
                              formsList?.filter(
                                (x) => x?.FormID == 99 && x?.IsDelete
                              )?.length > 0 ? (
                                <Link
                                  to="#"
                                  className="icon-box icon-box-md me-1"
                                  title="Delete"
                                  onClick={() => {
                                    delete_Record(
                                      POST_ItemDCDelete,
                                      {
                                        ItemDCIDEncrypted:
                                          item?.ItemDCIDEncrypted,
                                        ModifiedByEncrypted:
                                          AuthUser?.ReferenceIDEncrypt
                                            ? AuthUser?.ReferenceIDEncrypt
                                            : "0",
                                      },
                                      setIsLoading,
                                      fnCallback,
                                      item.DCNo
                                    );
                                  }}
                                >
                                  {SVGICON.DeleteDanger}
                                </Link>
                              ) : (
                                ""
                              )}
                              <Link
                                to="#"
                                className="icon-box icon-box-md me-2"
                                title="Print"
                                onClick={() => {
                                  getItemDCPrintHTMLContents(
                                    item.ItemDCIDEncrypted
                                  );
                                }}
                              >
                                {SVGICON.Printer}
                              </Link>
                            </td>
                            <td>{item.DCNo}</td>
                            <td>{item.CustomerName}</td>
                            <td>{item.EmployeeName}</td>
                            <td style={{ textAlign: "left" }}>{item.DCDate}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={5} style={{ textAlign: "left" }}>
                            <div>{"No Record Found..."}</div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <div className="d-sm-flex text-center justify-content-between align-items-center">
                    <CustomSizePerPage
                      getData={getData}
                      currentSizePerPage={currentSizePerPage}
                    />
                    <div className="dataTables_info">
                      Showing{" "}
                      {recordCount > 0
                        ? (currentPage - 1) * currentSizePerPage + 1
                        : 0}{" "}
                      to{" "}
                      {recordCount > currentPage * currentSizePerPage
                        ? currentPage * currentSizePerPage
                        : recordCount}{" "}
                      of {recordCount} entries
                    </div>
                    <CustomPaginationButtons
                      totalPages={recordCount / currentSizePerPage}
                      currentPage={currentPage}
                      currentSizePerPage={currentSizePerPage}
                      getData={getData}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Spin>
        </div>
      </div>
      <div style={{ display: "none" }}>
        <iframe
          id={`iFrameItemDC`}
          title="Item DC"
          width="100%"
          style={{ height: "100vh", display: "none" }}
          frameBorder="0"
          srcDoc=""
        ></iframe>
      </div>
    </>
  );
};

export default InventoryItemDC;
